import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { filter } from 'rxjs';
import { PriceFacade } from '../facades/price.facade';

export const priceRatesLoaded = (): CanActivateFn => {
    return () => {
        const priceFacade = inject(PriceFacade);
        priceFacade.getExchangeRates();

        return priceFacade.exchangeRatesIsLoaded$.pipe(filter((loaded) => loaded === true));
    };
};
